// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
// Stores
import { EventPublishingStore } from "@ms/uno-fluxcore/lib/local/stores/EventPublishingStore";
import { Store } from "../Store";
// Utilities
import { Temporal } from "temporal-polyfill-lite";
import { logUnreachableAction } from "../../utilities/LoggingUtilities";
/**
 * Store for user and app activity data
 */ export class ActivityStore extends EventPublishingStore {
    get name() {
        return Store.Activity;
    }
    getLastExchangeMailboxWarmupCallTimestamp(groupId) {
        return this.lastExchangeMailboxWarmupCallTimestamp[groupId] || null;
    }
    getLastUserActivityTimestamp() {
        return this.lastUserActivityTimestamp;
    }
    /**
     * This handles actions. It is basically a switch statement based on the action's type that interprets the action and provides
     * the proper hooks into the store's internal methods. This allows an action to result in an update to the state of the store, via the dispatcher.
     * @param action The action to be handled.
     */ handleAction(action) {
        let storeChanged = false;
        switch(action.type){
            case ActionType.FetchGroupConversationThreadAction:
                storeChanged = this.handleFetchGroupConversationThreadAction(action);
                break;
            case ActionType.UpdateUserActivityTimestamp:
                storeChanged = this.handleUpdateUserActivityTimestampAction(action);
                break;
            default:
                logUnreachableAction(this, this.loggers, action);
                return;
        }
        if (storeChanged) {
            this.publishStoreChangedEvent();
        }
    }
    /**
     * Update lastExchangeMailboxWarmupCallTimestamp when this action is fired
     * @param action The action fired for making fetchGroupConversationThreadAsync call.
     */ handleFetchGroupConversationThreadAction(action) {
        this.lastExchangeMailboxWarmupCallTimestamp[action.groupId] = action.timestamp;
        return true;
    }
    /**
     * Update lastUserActivityTimestamp when this action is fired
     * @param action The action fired when user makes any action.
     */ handleUpdateUserActivityTimestampAction(action) {
        this.lastUserActivityTimestamp = action.timestamp;
        return true;
    }
    constructor(loggers){
        super(), this.loggers = loggers, // For Group Mailbox warm-up.
        this.lastExchangeMailboxWarmupCallTimestamp = {};
        this.lastUserActivityTimestamp = Temporal.Now.instant();
    }
}
